import React from 'react'

import Button from '@material-ui/core/Button'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import Typography from '@material-ui/core/Typography'
import withStyles from '@material-ui/core/styles/withStyles'
import styles from '../styles'

const SelectedOrganization = ({ classes, selected }) => (
  <ListItem>
   <div className={classes.organizations__icon__list__wrapper}>
      <Typography className={classes.organizations__icon}>
        {selected.name[0]}
      </Typography>
   </div>
    <div>
      <ListItemText primary={selected.name} data-testid="selectedOrganizationName" />
      <Typography variant="caption" data-testid="selectedOrganizationLabel">
        {selected.email}
      </Typography>
    </div>
  </ListItem>
)

export default withStyles(styles)(SelectedOrganization)
